import { DynamicProductCatalog } from "@inter-ikea-core/core";
export default class CatalogService {
    constructor({ catalog, templates, core, catalogModifiers = [] }) {
        this.catalogModifiers = [];
        this.modifyCatalogProducts = (catalogProducts, catalogModifiers) => {
            const [modifier, ...rest] = catalogModifiers;
            if (!modifier)
                return catalogProducts;
            const modifiedCatalog = modifier({
                catalogProducts: catalogProducts,
                originalCatalogProducts: Object.assign({}, this.catalog.products),
            });
            if (!rest.length)
                return modifiedCatalog;
            return this.modifyCatalogProducts(modifiedCatalog, rest);
        };
        this.createCatalog = () => (Object.assign(Object.assign({}, this.catalog), { products: this.modifyCatalogProducts(this.catalog.products, this.catalogModifiers) }));
        this.generateCatalog = () => {
            this.processedCatalog = this.createCatalog();
            return new DynamicProductCatalog(JSON.stringify(this.processedCatalog), JSON.stringify(this.templates), "");
        };
        this.loadDynamicProductCatalog = () => {
            this.core.services.productManager.addCatalog(this.generateCatalog());
        };
        this.core = core;
        this.catalog = catalog;
        this.templates = templates;
        this.catalogModifiers = [...this.catalogModifiers, ...catalogModifiers];
    }
    get Catalog() {
        return this.core.services.productManager.catalogs.find((c) => c.rangeId() === this.catalog.range);
    }
}
